import { render, staticRenderFns } from "./AppTransportDocumentField.vue?vue&type=template&id=f45c91ae&scoped=true"
import script from "./AppTransportDocumentField.vue?vue&type=script&lang=js"
export * from "./AppTransportDocumentField.vue?vue&type=script&lang=js"
import style0 from "./AppTransportDocumentField.vue?vue&type=style&index=0&id=f45c91ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f45c91ae",
  null
  
)

export default component.exports